import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "A technical post about cake",
  "description": "",
  "published": "2011-10-14T00:00:00.000Z",
  "redirect_from": ["/blog/a-technical-post-about-cake/swizec/2626"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Very early in the morning today (11am) I set out to make a rainbow `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Unicorn",
        "title": "Unicorn"
      }}>{`unicorn`}</a>{` cake for `}<a parentName="p" {...{
        "href": "http://twitter.com/ponywithhiccups"
      }}>{`@ponywithhiccups`}</a>{`. Because rainbows are cool and you can't have a proper rainbow without a unicorn thrown into the mix.`}</p>
    <p>{`This is the model cake I was going to make ... perhaps even awesomer.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/10/Rainbow_2_by_bittykate15.jpg",
        "alt": null,
        "title": "Proto cake"
      }}></img></p>
    {
      /*more*/
    }
    <p>{`Sure, I hit the very first snag as I was buying ingredients. Got home and the `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Food_coloring",
        "title": "Food coloring"
      }}>{`food colourings`}</a>{` I thought I had bought were in fact very brightly coloured aromas. The cake would smell magnificently, but sure wouldn't be very colourful ...`}</p>
    <p>{`Like any good person with an `}<a parentName="p" {...{
        "href": "http://www.apple.com/iphone",
        "title": "iPhone"
      }}>{`iPhone`}</a>{` and an Instagram account I took a bunch of photos.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/10/tumblr_lt1vmgp30U1qekjngo1_50010.jpg",
        "alt": null,
        "title": "Shopping list"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/10/tumblr_lt24i0Xa601qekjngo1_50010.jpg",
        "alt": null,
        "title": "Stuff"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/10/tumblr_lt28wyJXyg1qekjngo1_5009.jpg",
        "alt": null,
        "title": "Dyed batter"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/10/tumblr_lt2h1exdVZ1qekjngo1_5009.jpg",
        "alt": null,
        "title": "Moussed up caek"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/10/tumblr_lt2j9ptowg1qekjngo1_5009.jpg",
        "alt": null,
        "title": "Final ... thing"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/10/3qqjy-1-768x1024.jpg",
        "alt": null,
        "title": "Slice of rainbow"
      }}></img></p>
    <p>{`As you can see from the photos this was a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Software_release_life_cycle",
        "title": "Software release life cycle"
      }}>{`beta version`}</a>{` of this cake and its got a bunch of bugs.`}</p>
    <p>{`Namely the recipe I used for the batter was freakishly tiny and I made it bigger by feel. Apparently that made it more pancakey than biscuity and fluffy and the cake pan thing I was using turned out to be larger than anticipated which gave me barely enough batter to properly cover the pan wall-to-wall, which in turn made the individual layers of cake look a whole lot like pancakes.`}</p>
    <p>{`Hard, unfluffy, heavy, pancakes.`}</p>
    <p>{`I also ended up screwing up the first batch of mousse and had to run off to the store again for ingredients to make a new one. This sort of turned out alright, but should have been a bit harder and less liquid. That might work a bit better in a cake situation and be less runny.`}</p>
    <p>{`The next fail was with using the wrong recipe to make snowy white frosting. Turned out to be more yellowy white and way way not enough of it.`}</p>
    <p>{`Luckily I had just enough mousse left over to improvise and make the cake two colours on the outside.`}</p>
    <p>{`The unicorn's corn ... well I have `}<em parentName="p">{`no`}</em>{` idea what that looks like ...`}</p>
    <p>{`All in all, a solid 8 hours of work for a cake that sort of almost looks okay and kind of tastes alright if you're hungry enough.`}</p>
    <p>{`Where's git reset --hard when you need it?`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://verbalinsanity.wordpress.com/2011/08/10/project-1-rainbow-cake/"
        }}>{`Project #1 - Rainbow Cake.`}</a>{` (verbalinsanity.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.geeksaresexy.net/2011/10/09/best-cake-in-the-verse-pics/"
        }}>{`Best Cake in the 'Verse? `}{`[`}{`Pics`}{`]`}</a>{` (geeksaresexy.net)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://kellsbells1008.wordpress.com/2011/09/12/how-to-rainbow-baking/"
        }}>{`How To: Rainbow Baking`}</a>{` (kellsbells1008.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://lifewithgusto.wordpress.com/2011/10/13/the-cake-files-part-i/"
        }}>{`The Cake Files, Part I`}</a>{` (lifewithgusto.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://salutadventures.com/2011/10/11/the-most-dangerous-cake-in-the-world/"
        }}>{`The Most Dangerous Cake in the World`}</a>{` (salutadventures.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=7bf5dc33-8456-4419-8d36-7f45156c0b84",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      